const clearCssClassName = (iframeRef, className) => {
    if(!iframeRef) {
        return;
    }

    const iframe = iframeRef.current;
    const iframeDocument = iframe?.contentWindow || (iframe?.contentDocument?.document || iframe?.contentDocument);

    if(!iframeDocument || !className) {
        return;
    }

    let elements = 1;

    while(elements.length !== 0) {
        elements = iframeDocument.document.getElementsByClassName(className);

        for (let i=0 ; i < elements.length; i++){
            elements[i].classList.remove(className);
        }
    }
};

export default clearCssClassName;
